import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toastify } from 'utils/toastify';
import { CancellationPoliciesService } from 'data/services';

function CancellationPolicyEdit(props) {
    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
        setError,
    } = useForm();
    const [isFormSubmitting, setFormSubmitting] = useState();
    const [model, setModel] = useState();
    const { t } = useTranslation();
    useEffect(() => {
        const api = async () => {
            const response = await CancellationPoliciesService.getById(props.id)
            setModel(response.data)
            reset(response.data)
        }
        api()
    }, [])
    const handleDiscard = () => {
        props.onDiscard()
    }
    const onSubmit = async (data) => {
        setFormSubmitting(true);
        if (model.hoursBeforeCancellation == data.hoursBeforeCancellation && model.returnPercentage == data.returnPercentage) {
            handleDiscard();
            return;
        }
        if (data.hoursBeforeCancellation <= 0) {
            setError('hoursBeforeCancellation', { type: 'minLength' })
            setFormSubmitting(false)
            return
        }
        if (data.returnPercentage > 100) {
            setError('returnPercentage', { type: 'maxLength' })
            setFormSubmitting(false)
            return
        }
        if (data.returnPercentage < 0) {
            setError('returnPercentage', { type: 'minLength' })
            setFormSubmitting(false)
            return
        }
        const response = await CancellationPoliciesService.edit({ Id: data.id, ...data })
        setFormSubmitting(false);
        if (response.isSuccess) {
            toastify.success(t("SUCCESS_EDIT_CANCELLATION_POLICY"),<img className="Toastify__toast-icon--success" src="../assets/images/checkwhite.png"/>)
            props.editCurrentState(response.data)
            handleDiscard()
        }
        else {
            toastify.error(t("ERROR_EDITING_CANCELLATION_POLICY"))
            handleDiscard()
        }


    };
    return (
        <>
            <div className="position-fixed z-index-master top-0 start-0 bottom-0 end-0 w-100 bg-dark bg-lighten-lg bg-opacity-50 d-flex flex-column justify-content-center align-items-center">
                <div  className="card shadow mw-90">
                    <div className="col-lg-12">
                        <div className="row p-3">
                            <div className="col-12 ">
                                <h1 className="h4 mb-0">{t("EDIT_CANCELLATION_POLICY")}</h1>
                            </div>
                        </div>

                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                                <div className='row'>
                                    <div className='col-md-6 col-sm-12'>
                                        <div className="mb-3">
                                            <label className="form-label">{t("HOURS_BEFORE_CANCELLATION")}</label>
                                            <input
                                                {...register("hoursBeforeCancellation", {
                                                    required: t("HOURS_BEFORE_CANCELLATION_IS_REQUIRED"),

                                                })}
                                                type="number"
                                                className="form-control"
                                                placeholder={t("HOURS_BEFORE_CANCELLATION")}
                                            />
                                            {errors.hoursBeforeCancellation && errors.hoursBeforeCancellation.type === "required" && <span className="text-danger">{t("HOURS_BEFORE_CANCELLATION_IS_REQUIRED")}</span>}
                                            {errors.hoursBeforeCancellation && errors.hoursBeforeCancellation.type === "minLength" && <small className="text-danger">{t("HOURS_BEFORE_CANCELLATION_LESS_THAN_0")}</small>}
                                        </div>
                                    </div>
                                    <div className='col-md-6  col-sm-12'>
                                        <div className="mb-3">
                                            <label className="form-label">{t("RETURN_PERCENTAGE")}</label>
                                            <input
                                                {...register("returnPercentage", {
                                                    required: t("RETURN_PERCENTAGE_IS_REQUIRED"),

                                                })}
                                                type="number"
                                                className="form-control"
                                                placeholder={t("RETURN_PERCENTAGE")}
                                            />
                                            {errors.returnPercentage && errors.returnPercentage.type === "required" && <span className="text-danger">{t("RETURN_PERCENTAGE_IS_REQUIRED")}</span>}
                                            {errors.returnPercentage && errors.returnPercentage.type === "maxLength" && <small className="text-danger">{t("RETURN_PERCENTAGE_IS_MORE_THAN_100")}</small>}
                                            {errors.returnPercentage && errors.returnPercentage.type === "minLength" && <small className="text-danger">{t("RETURN_PERCENTAGE_IS_LESS_THAN_0")}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mt-4">
                                    <button className="btn text-secondary border-0 me-2" onClick={() => handleDiscard()}>
                                        {t("DISCARD")}
                                    </button>
                                    <button disabled={isFormSubmitting} type="submit" className="btn btn-primary">
                                        {isFormSubmitting && <i className="fa fa-spin fa-spinner"></i>}
                                        {t("SAVE")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CancellationPolicyEdit
